import type { TrackingEventName, TrackingProperties } from "../types";

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

// Zaraz's dataLayer compatibility mode turns each push into a Zaraz track
// event named after `event`, which its tools trigger on. Properties are read
// in Zaraz as `{{ client.<name> }}`, e.g. `{{ client.userId }}`.
const sendToDataLayer = (
  event: TrackingEventName,
  payload: TrackingProperties,
) => {
  window.dataLayer ??= [];
  window.dataLayer.push({ event, ...payload });
};

export default sendToDataLayer;
